var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import _ from 'lodash';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import GLOBAL_VUE from '../../globalVue';
import PurchaseRefundForUpperSupService from '../../api/PurchaseRefundForUpperSupService';
import { summaries } from "../../helper/util";
import { EOrderSubType } from "../../enum/EUpperPurchase";
import AddDialog from "./components/GoodAdd.vue";
import Header from "./components/AddHeader.vue";
import RequiredMixin from "../../components/renderHeader/RequiredMixin";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eOrderSubType = EOrderSubType;
        _this.tableHeight = document.documentElement.clientHeight - 360;
        _this.data = [];
        _this.formData = {
            supplier_upper_id: '',
            organ_id: '',
            depot_id: '',
            order_sub_type: EOrderSubType['有单退货'],
            purchasing_agent_id: '',
            upper_warehouse_order_id: '',
            upper_warehouse_order_code: '',
            certificate_img: [],
            warehouse_date: new Date().format('yyyy-MM-dd'),
            order_icomment: ''
        };
        _this.handleStatus = EHandleStatus.Add;
        _this.orderid = '';
        _this.canSave = true;
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.created = function () {
        this.PurchaseRefundForUpperSupService = PurchaseRefundForUpperSupService.getInstance();
        if (this.orderid) {
            this.getDetail();
        }
    };
    default_1.prototype.mounted = function () {
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid,
            is_edit: 1
        };
        this.PurchaseRefundForUpperSupService.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            if (data.purchasing_agent_id === 0) {
                data.purchasing_agent_id = '';
            }
            _this.data = data.detail;
            _this.formData = Object.assign({}, _this.formData, data, {
                certificate_img: JSON.parse(data.certificate_img).map(function (item) {
                    return {
                        url: item
                    };
                })
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.save = function () {
        var _this = this;
        var formData = this.formData;
        if (!this.checkSave()) {
            return;
        }
        if (!this.data || !this.data.length) {
            this.$message.warning("请添加货品");
            return;
        }
        this.canSave = false;
        if (this.handleStatus === EHanldeStatus.Add) {
            var data = this.data;
            var params = __assign({}, formData, { certificate_img: JSON.stringify(formData.certificate_img.map(function (item) { return item.url; })), data: JSON.stringify(data) });
            this.PurchaseRefundForUpperSupService.addOrder(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success("保存成功");
                    window._czc.push(["_trackEvent", '采购退货添加', '采购退货添加保存']);
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            }).catch(function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            });
        }
        else {
            var data = this.data;
            var params = __assign({}, formData, { order_id: this.orderid, certificate_img: JSON.stringify(formData.certificate_img.map(function (item) { return item.url; })), data: JSON.stringify(data) });
            delete params.detail;
            delete params.certificate_img_arr;
            this.PurchaseRefundForUpperSupService.updOrder(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success("保存成功");
                    window._czc.push(["_trackEvent", '采购退货编辑', '采购退货编辑保存']);
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.canSave = true;
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            });
        }
    };
    default_1.prototype.checkSave = function () {
        if (!this.canHandleGoods()) {
            return false;
        }
        if (!this.formData.warehouse_date) {
            this.$message.warning("请选择退货日期");
            return false;
        }
        var flag = true, msg = [];
        this.data.map(function (row) {
            if ((!row.order_detail_amount && row.order_detail_amount !== 0) || row.order_detail_amount <= 0) {
                flag = false;
                msg.push('退货数量必填，退货数量大于0');
            }
            if ((!row.order_detail_uprice && row.order_detail_uprice !== 0) || row.order_detail_uprice < 0) {
                flag = false;
                msg.push('单价必填，单价大于等于0');
            }
        });
        if (!flag) {
            this.$message.warning('货品信息不可为空，退货数量大于0，单价大于等于0。');
            return false;
        }
        return true;
    };
    default_1.prototype.canHandleGoods = function () {
        if (!this.formData.supplier_upper_id) {
            this.$message.warning("请选择供应商");
            return;
        }
        if (!this.formData.organ_id) {
            this.$message.warning("请选择退货机构");
            return;
        }
        if (!this.formData.depot_id) {
            this.$message.warning("请选择采购仓库");
            return;
        }
        if (this.formData.order_sub_type == this.eOrderSubType['有单退货'] && !this.formData.upper_warehouse_order_id) {
            this.$message.warning("请选择入库单号");
            return;
        }
        return true;
    };
    default_1.prototype.toAdd = function () {
        var _this = this;
        if (!this.canHandleGoods()) {
            return false;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                supplier_upper_id: this.formData.supplier_upper_id,
                organ_id: this.formData.organ_id,
                depot_id: this.formData.depot_id,
                order_sub_type: this.formData.order_sub_type,
                upper_warehouse_order_id: this.formData.upper_warehouse_order_id
            }
        }, {
            title: "添加货品",
            width: 900,
            height: 550
        });
        dialog.instance.$on("submit", function (res) {
            _this.data = res;
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Add) {
                window._czc.push(["_trackEvent", '采购退货添加', '添加货品']);
            }
            else {
                window._czc.push(["_trackEvent", '采购退货编辑', '添加货品']);
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择货品");
            return;
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHanldeStatus.Add) {
                window._czc.push(["_trackEvent", '采购退货添加', '删除货品']);
            }
            else {
                window._czc.push(["_trackEvent", '采购退货编辑', '删除货品']);
            }
        }, function (err) { });
    };
    default_1.prototype.emptyGood = function () {
        this.data = [];
    };
    default_1.prototype.resetGood = function (data) {
        var _this = this;
        data.forEach(function (item) {
            _this.calcGoodRow(item, 'order_detail_amount');
        });
        this.data = data;
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        this.calcGoodRow(row, type);
    };
    default_1.prototype.calcGoodRow = function (row, type) {
        if (row[type])
            row[type] = String(row[type]).replace(/^(.*\..{4}).*$/, "$1");
        if (type == 'order_detail_amount' || type == 'order_detail_uprice') {
            if (row.order_detail_amount && row.order_detail_uprice) {
                row.order_detail_money = Number(_.multiply(row.order_detail_amount * row.order_detail_uprice)).toFixedNoZero(2);
            }
            else {
                row.order_detail_money = row.order_detail_money ? row.order_detail_money : '';
            }
        }
        if (type === 'order_detail_tax_rate') {
            if (row.order_detail_tax_rate) {
                row.order_detail_tax_rate = Math.floor(Math.abs(row.order_detail_tax_rate) * 100) / 100;
            }
        }
    };
    default_1.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_amount", "order_detail_uprice", "order_detail_money"];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        if (this.formData.order_sub_type == EOrderSubType['有单退货']) {
            sums[8] = '';
            sums[9] = '';
        }
        else {
            sums[7] = '';
            sums[8] = '';
        }
        return sums;
    };
    default_1 = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            methods: {}
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
